import { z } from "zod";
import { isPasswordStrengthBlocked } from "@/lib/password-strength";

const personNameSchema = z
  .string()
  .trim()
  .min(2, "Required or minimum 2 characters")
  .max(100, "Must be 100 characters or less");

export const userRoleSchema = z.enum(["user", "manager", "admin"]);

export const createUserFormSchema = z.object({
  firstName: personNameSchema,
  lastName: personNameSchema,
  email: z.email("Enter a valid email address"),
  password: z
    .string()
    .min(8, "Password must be at least 8 characters")
    .refine((value) => !isPasswordStrengthBlocked(value), {
      message: "Password is too weak — add numbers or special characters",
    }),
  role: userRoleSchema,
  team: z.string().trim().min(1, "Team is required"),
});

export type CreateUserFormValues = z.infer<typeof createUserFormSchema>;
